// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__jaq07","requiredAsterisk":"Info_requiredAsterisk__1_gMf"};